<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <p>Usage:</p>
    <div :class="['mt-16']">
      <code>&lt;vc-component v-tooltip="{position: 'top', text: 'tooltip text'}"&gt;...&lt;/vc-component&gt;</code>
    </div>
    <div :class="['mt-16']">
      <code>&lt;div v-tooltip="{position: 'top', text: 'tooltip text'}"&gt;...&lt;/div&gt;</code>
    </div>
    <example-title src="example-1.html" title="Button" />
    <vc-layout :spacing="8" :class="['align-center']">
      <vc-col :span="6" xs12 v-for="(direction, index) in directions" :key="`buttons-${index}`">
        <vc-button block v-tooltip="{position: direction.pos, text: direction.pos}" :color="direction.color">{{ direction.pos }} tooltip</vc-button>
      </vc-col>
    </vc-layout>

    <example-title src="example-1.html" title="Avatar" />
    <vc-layout :spacing="8" :class="['align-center']">
      <vc-col :span="6" xs12 v-for="(direction, index) in directions" :key="`avatars-${index}`">
        <vc-avatar :class="['elevation-8', 'ma-8']" :src="`/static/images/avatar-0${index + 1}.png`" :color="direction.color" v-tooltip="{position: direction.pos, text: direction.pos}" />
      </vc-col>
    </vc-layout>

    <example-title src="example-1.html" title="Switcher" />
    <vc-layout :spacing="8">
      <vc-col :span="6" xs12 v-for="(direction, index) in directions" :key="`switchers-${index}`">
        <vc-switcher
          :color="direction.color"
          :class="['ma-8']"
          :name="direction.pos"
          v-model="sw1"
          v-tooltip="{position: direction.pos, text: direction.pos}"
        >{{ direction.pos }} tooltip</vc-switcher>
      </vc-col>
    </vc-layout>

    <example-title src="example-1.html" title="Checkbox" />
    <vc-layout :spacing="8">
      <vc-col :span="6" xs12 v-for="(direction, index) in directions" :key="`checkboxes-${index}`">
        <vc-checkbox
          :color="direction.color"
          :class="['ma-8']"
          :name="direction.pos"
          v-model="chk1"
          v-tooltip="{position: direction.pos, text: direction.pos}">{{ direction.pos }} tooltip</vc-checkbox>
      </vc-col>
    </vc-layout>

    <example-title src="example-1.html" title="Tag" />
    <vc-layout :spacing="8">
      <vc-col :span="6" xs12 v-for="(direction, index) in directions" :key="`tags-${index}`">
        <vc-tag
          :color="direction.color"
          closable
          v-tooltip="{position: direction.pos, text: direction.pos}"
        >{{ direction.pos }} tooltip</vc-tag>
      </vc-col>
    </vc-layout>

    <example-title src="example-1.html" title="Text" />
    <vc-layout :spacing="8">
      <vc-col v-for="(direction, index) in directions" :key="`text-${index}`" :span="6" xs12>
        <vc-text
          :color="direction.color"
          :placeholder="`${direction.pos} tooltip`"
          :label="`${direction.pos} tooltip`"
          :name="direction.pos"
          :icon-left="direction.icon"
          v-tooltip="{position: direction.pos, text: direction.pos}" />
      </vc-col>
    </vc-layout>

    <example-title src="example-1.html" title="Radio Group" />
    <vc-layout :spacing="8">
      <vc-col v-for="(direction, index) in directions" :key="`text-${index}`" :span="6" xs12>
        <vc-radio-group
          :name="`guitars-${direction.pos}`"
          :color="directions[index].color"
          width="90px"
          v-model="mGuitars">
          <vc-radio
            v-tooltip="{position: directions[index].pos, text: directions[index].pos}"
            v-for="(guitar, index) in guitars"
            :value="guitar"
            :key="index">{{ guitar }}</vc-radio>
        </vc-radio-group>
      </vc-col>
    </vc-layout>
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'TooltipPage',
  data () {
    return {
      sw1: true,
      chk1: true,
      h3: ['title', 'font-grey', 'font-l-600'],
      title: null,
      description: null,
      guitars: ['Jackson', 'B.C. Rich', 'ESP', 'Epiphone'],
      mGuitars: 'ESP',
      directions: [{
        pos: 'top',
        color: 'primary',
        icon: 'home'
      }, {
        pos: 'right',
        color: 'warning',
        icon: 'schedule'
      }, {
        pos: 'bottom',
        color: 'success',
        icon: 'accessibility'
      }, {
        pos: 'left',
        color: 'error',
        icon: 'functions'
      }]
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tooltip.vue